/*
 * Leaflet-IIIF 2.0.1
 * IIIF Viewer for Leaflet
 * by Jack Reed, @mejackreed
 */

function falseFn() {
  return false
}
let emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="

L.GridLayer.IiifRotate = L.GridLayer.extend({
  options: {
    continuousWorld: true,
    tileSize: 256,
    updateWhenIdle: true,
    tileFormat: "jpg",
    fitBounds: true,
    setMaxBounds: false,
    rotate: 0,
  },
  initialize: function (url, options) {
    options = typeof options !== "undefined" ? options : {}

    if (options.maxZoom) {
      this._customMaxZoom = true
    }

    // Check for explicit tileSize set
    if (options.tileSize) {
      this._explicitTileSize = true
    }

    // Check for an explicit quality
    if (options.quality) {
      this._explicitQuality = true
    }

    options = L.setOptions(this, options)
    this._infoUrl = url
    this._baseUrl = this._templateUrl()
    this._infoPromise = this._getInfo()

    this.on("tileunload", function (e) {
      e.tile.firstChild.onload = null
    })
  },
  createTile: function (coords, done) {
    let _this = this,
      x = coords.x,
      y = coords.y,
      zoom = coords.z,
      scale = Math.pow(2, _this.maxNativeZoom - zoom),
      tileBaseSize = _this.options.tileSize * scale
    let minx = 0
    let maxx = 0
    let miny = 0
    let maxy = 0
    if (this.options.rotate == 90) {
      minx = y * tileBaseSize
      maxx = Math.min(minx + tileBaseSize, _this.x)
      miny = Math.max(0, this.y - (x + 1) * tileBaseSize)
      maxy = this.y - x * tileBaseSize
    } else if (this.options.rotate == 180) {
      minx = Math.max(0, this.x - (x + 1) * tileBaseSize)
      maxx = this.x - x * tileBaseSize
      miny = Math.max(0, this.y - (y + 1) * tileBaseSize)
      maxy = this.y - y * tileBaseSize
    } else if (this.options.rotate == 270) {
      minx = Math.max(0, this.x - (y + 1) * tileBaseSize)
      maxx = this.x - y * tileBaseSize
      miny = x * tileBaseSize
      maxy = Math.min(miny + tileBaseSize, _this.y)
    } else {
      minx = x * tileBaseSize
      miny = y * tileBaseSize
      maxx = Math.min(minx + tileBaseSize, _this.x)
      maxy = Math.min(miny + tileBaseSize, _this.y)
    }
    let width = maxx - minx
    let height = maxy - miny

    let tileUrl = L.Util.template(
      this._baseUrl,
      L.extend(
        {
          format: _this.options.tileFormat,
          quality: _this.quality,
          region: [minx, miny, width, height].join(","),
          rotation: 0,
          size:
            width > height
              ? Math.round(width / scale) + ","
              : "," + Math.round(height / scale),
        },
        this.options
      )
    )
    let tile = document.createElement("div")

    // let c = document.createElement("div");
    // c.innerHTML = [
    //   this.options.rotate,
    //   coords.x,
    //   coords.y,
    //   coords.z,
    //   tileUrl,
    // ].join(", ");
    // c.style.position = "absolute";
    // c.style.zIndex = 999;
    // tile.appendChild(c);
    // tile.style.outline = "1px solid red";
    let img = document.createElement("img")
    tile.appendChild(img)
    img.alt = ""
    img.setAttribute("role", "presentation")
    img.style.transformOrigin = "top left"
    img.style.position = "absolute"
    img.style.left = 0
    img.style.top = 0
    if (this.options.rotate === 90)
      img.style.transform = "scale(1.001) rotate(90deg) translateY(-100%)"
    else if (this.options.rotate === 180)
      img.style.transform =
        "scale(1.001) rotate(180deg) translateY(-100%) translateX(-100%)"
    else if (this.options.rotate === 270)
      img.style.transform = "scale(1.001) rotate(270deg) translateX(-100%)"
    else img.style.transform = "scale(1.001)"

    img.onload = function () {
      //   let height = rot.naturalHeight,
      //     width = rot.naturalWidth;

      //   //   console.info("on-load", height, tile.height);

      //   // No need to resize if tile is 256 x 256
      //   if (height === 256 && width === 256) return;

      //   rot.style.width = width + "px";
      //   rot.style.height = height + "px";
      done(null, tile)
    }
    img.onerror = function () {
      // tile.innerHTML = "error " + coords.x + " " + coords.y;
      done(null, tile)
    }
    img.src = tileUrl
    return tile
  },
  _isVertical: function () {
    return this.options.rotate === 90 || this.options.rotate === 270
  },
  _abortLoading: function () {
    let i, tile
    for (i in this._tiles) {
      if (this._tiles[i].coords.z !== this._tileZoom) {
        tile = this._tiles[i].el

        if (tile) {
          tile.firstChild.onload = falseFn
          tile.firstChild.onerror = falseFn

          if (!tile.firstChild.complete) {
            tile.firstChild.src = emptyImageUrl
            tile.parentNode.removeChild(tile)
            delete this._tiles[i]
          }
        }
      }
    }
  },
  _removeTile: function (key) {
    let tile = this._tiles[key]
    if (!tile) {
      return
    }
    tile.el.firstChild.src = emptyImageUrl

    return L.GridLayer.prototype._removeTile.call(this, key)
  },
  _tileReady: function (coords, err, tile) {
    if (!this._map || (tile && tile.firstChild.src === emptyImageUrl)) {
      return
    }
    return L.GridLayer.prototype._tileReady.call(this, coords, err, tile)
  },
  _isValidTile: function (coords) {
    let _this = this
    let zoom = coords.z
    let sizes = _this._tierSizes[zoom]
    let x = this._isVertical() ? coords.y : coords.x
    let y = this._isVertical() ? coords.x : coords.y

    if (zoom < 0 && x >= 0 && y >= 0) {
      return true
    }

    if (!sizes) return false

    // console.info(
    //   zoom,
    //   coords,
    //   sizes,
    //   0 <= x && x < sizes[0] && 0 <= y && y < sizes[1]
    // );

    if (0 <= x && x < sizes[0] && 0 <= y && y < sizes[1]) {
      return true
    } else {
      return false
    }
  },
  onAdd: function (map) {
    let _this = this
    this._infoPromise.then(function () {
      // Store unmutated imageSizes
      _this._imageSizesOriginal = _this._imageSizes.slice(0)

      // Set maxZoom for map
      _this._prev_map_layersMaxZoom = _this._map._layersMaxZoom
      map._layersMaxZoom = _this.maxZoom

      // Set minZoom and minNativeZoom based on how the imageSizes match up
      let smallestImage = _this._imageSizes[0]

      let mapSize = _this._map.getSize()
      let newMinZoom = 0
      // Loop back through 5 times to see if a better fit can be found.
      for (let i = 1; i <= 5; i++) {
        if (smallestImage.x > mapSize.x || smallestImage.y > mapSize.y) {
          smallestImage = smallestImage.divideBy(2)
          _this._imageSizes.unshift(smallestImage)
          newMinZoom = -i
        } else {
          break
        }
      }
      _this.options.minZoom = newMinZoom
      _this.options.minNativeZoom = newMinZoom
      _this._prev_map_layersMinZoom = _this._map._layersMinZoom
      _this._map._layersMinZoom = newMinZoom

      // Call add GridLayer
      L.GridLayer.prototype.onAdd.call(_this, map)

      if (_this.options.fitBounds) {
        _this._fitBounds()
      }

      if (_this.options.setMaxBounds) {
        _this._setMaxBounds()
      }

      _this.fire("iiif-load-json")
    })
  },
  onRemove: function (map) {
    let _this = this

    map._layersMinZoom = _this._prev_map_layersMinZoom
    map._layersMaxZoom = _this._prev_map_layersMaxZoom
    _this._imageSizes = _this._imageSizesOriginal

    // Remove maxBounds set for this image
    if (_this.options.setMaxBounds) {
      map.setMaxBounds(null)
    }

    // Call remove TileLayer
    L.TileLayer.prototype.onRemove.call(_this, map)
  },
  _fitBounds: function () {
    let _this = this

    // Find best zoom level and center map
    let initialZoom = _this._getInitialZoom(_this._map.getSize())
    let offset = _this._imageSizes.length - 1 - _this.options.maxNativeZoom
    let zoom = initialZoom + offset
    let imageSize = _this._imageSizes[initialZoom + offset]
    if (imageSize) {
      let sw = _this._map.options.crs.pointToLatLng(
        L.point(0, this._isVertical() ? imageSize.x : imageSize.y),
        initialZoom
      )
      let ne = _this._map.options.crs.pointToLatLng(
        L.point(this._isVertical() ? imageSize.y : imageSize.x, 0),
        initialZoom
      )

      let bounds = L.latLngBounds(sw, ne)

      _this._map.fitBounds(bounds, { animate: true })
    }
  },
  _setMaxBounds: function () {
    let _this = this

    // Find best zoom level, center map, and constrain viewer
    let initialZoom = _this._getInitialZoom(_this._map.getSize())
    let imageSize = _this._imageSizes[initialZoom]
    let sw = _this._map.options.crs.pointToLatLng(
      L.point(0, imageSize.y),
      initialZoom
    )
    let ne = _this._map.options.crs.pointToLatLng(
      L.point(imageSize.x, 0),
      initialZoom
    )
    let bounds = L.latLngBounds(sw, ne)

    _this._map.setMaxBounds(bounds, true)
  },
  _getInfo: function () {
    let _this = this
    return new Promise(function (resolve, reject) {
      let xhr = new XMLHttpRequest()
      xhr.open("get", _this._infoUrl)
      xhr.onload = function () {
        let data = JSON.parse(xhr.responseText)
        _this.x = data.width
        _this.y = data.height

        let tierSizes = [],
          imageSizes = [],
          scale,
          width_,
          height_,
          tilesX_,
          tilesY_

        // Set quality based off of IIIF version
        if (data.profile instanceof Array) {
          _this.profile = data.profile[0]
        } else {
          _this.profile = data.profile
        }

        _this._setQuality()

        // Unless an explicit tileSize is set, use a preferred tileSize
        if (!_this._explicitTileSize) {
          // Set the default first
          _this.options.tileSize = 256
          if (data.tiles) {
            // Image API 2.0 Case
            _this.options.tileSize = data.tiles[0].width
          } else if (data.tile_width) {
            // Image API 1.1 Case
            _this.options.tileSize = data.tile_width
          }
        }

        function ceilLog2(x) {
          return Math.ceil(Math.log(x) / Math.LN2)
        }

        // Calculates maximum native zoom for the layer
        _this.maxNativeZoom = Math.max(
          ceilLog2(_this.x / _this.options.tileSize),
          ceilLog2(_this.y / _this.options.tileSize),
          0
        )
        _this.options.maxNativeZoom = _this.maxNativeZoom

        // console.info(_this.options.maxNativeZoom);

        // Enable zooming further than native if maxZoom option supplied
        if (
          _this._customMaxZoom &&
          _this.options.maxZoom > _this.maxNativeZoom
        ) {
          _this.maxZoom = _this.options.maxZoom
        } else {
          _this.maxZoom = _this.maxNativeZoom
        }

        for (let i = 0; i <= _this.maxZoom; i++) {
          scale = Math.pow(2, _this.maxNativeZoom - i)
          width_ = Math.ceil(_this.x / scale)
          height_ = Math.ceil(_this.y / scale)
          tilesX_ = Math.ceil(width_ / _this.options.tileSize)
          tilesY_ = Math.ceil(height_ / _this.options.tileSize)
          tierSizes.push([tilesX_, tilesY_])
          imageSizes.push(L.point(width_, height_))
        }

        _this._tierSizes = tierSizes
        _this._imageSizes = imageSizes
        resolve()
      }
      xhr.send()
    })
  },
  _setQuality: function () {
    let _this = this
    let profileToCheck = _this.profile

    if (_this._explicitQuality) {
      return
    }

    // If profile is an object
    if (typeof profileToCheck === "object") {
      profileToCheck = profileToCheck["@id"]
    }

    // Set the quality based on the IIIF compliance level
    switch (true) {
      case / ^ http:\/\/library.stanford.edu\/iiif\/image-api\/1.1\/compliance.html.*$/.test(
        profileToCheck
      ):
        _this.options.quality = "native"
        break
      // Assume later profiles and set to default
      default:
        _this.options.quality = "default"
        break
    }
  },
  _infoToBaseUrl: function () {
    return this._infoUrl.replace("info.json", "")
  },
  _templateUrl: function () {
    return (
      this._infoToBaseUrl() + "{region}/{size}/{rotation}/{quality}.{format}"
    )
  },
  _getInitialZoom: function (mapSize) {
    let _this = this
    let tolerance = 0.8
    let imageSize, x, y
    // Calculate an offset between the zoom levels and the array accessors
    let offset = _this._imageSizes.length - 1 - _this.options.maxNativeZoom
    for (let i = _this._imageSizes.length - 1; i >= 0; i--) {
      imageSize = _this._imageSizes[i]
      x = _this._isVertical() ? imageSize.y : imageSize.x
      y = _this._isVertical() ? imageSize.x : imageSize.y

      if (x * tolerance < mapSize.x && y * tolerance < mapSize.y) {
        return i - offset
      }
    }
    return 2
  },
})

L.GridLayer.iiifRotate = function (url, opts) {
  return new L.GridLayer.IiifRotate(url, opts)
}
